var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>"
    + alias2(lookupProperty(helpers,"t").call(alias1,"Click here to go to the conversation you're composing to.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":5},"end":{"line":1,"column":70}}}))
    + "</div>\n"
    + alias2(lookupProperty(helpers,"tooltip_hotkey_hints").call(alias1,"Ctrl",".",{"name":"tooltip_hotkey_hints","hash":{},"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":2,"column":35}}}))
    + "\n";
},"useData":true});